import { defineStore } from "pinia";
import type { WebModelGetLicenseContainerType } from "~/model/api/pLCnextStoreFrontendAPI.schemas";
import { getAllLicenseContainerTypes } from "~/model/api/pLCnextStoreFrontendAPI";
import { withErrorHandling } from "~/helpers/withErrorHandling";
import { withErrorMessage } from "~/helpers/withErrorMessage";
import { withLoading } from "~/helpers/withLoading";

interface State {
  licenseContainerTypes: WebModelGetLicenseContainerType[];
}

export const useLicenseContainerTypesStore = defineStore(
  "licenseContainerTypes",
  {
    // convert to a function
    state: (): State => ({
      licenseContainerTypes: [], // initial state
    }),
    getters: {},
    actions: {
      async loadLicenseContainerTypes() {
        const { data, error } = await withErrorHandling(
          withErrorMessage(withLoading(getAllLicenseContainerTypes())),
        );
        console.debug("loadLicenseContainerTypes: ", data, error);
        if (data) {
          this.licenseContainerTypes = data;
        }
      },

      // easily reset state using `$reset`
      clear() {
        this.$reset();
      },
    },
  },
);
